export default __webpack_public_path__ + "static/halima-3a3b397fd041822c090eceafd7846a6b.jpg";